import React from 'react';
import '../template-file-css/document-file-template.css';



export const LHH_ErPreparednessPlanAndAcknowledge = ({
    itemsRef,
    showErrorFor,

}) => {

    return (
        <form id='LHH_ErPreparednessPlanAndAcknowledge' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'><h3>Emergency Preparedness Plan</h3></p>
                <p className='w-750'>
                    In the event that your family was suddenly required to evacuate the area due to a natural disaster, where would your family relocate? Who would we be able to contact regarding your whereabouts?
                </p>
                <p className='w-750'><h3>Planned Evacuatin Destination</h3></p>
                <p className='w-750'><h4>In State Contact</h4></p>

                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Name:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Street Address:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>City/Zip:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' name='txtName' id='txtName' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' name='txtStreetAddress' id='txtStreetAddress' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' name='txtCity' id='txtCity' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Phone Number:</span>
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' name='txtPhoneNumber' id='txtPhoneNumber' className='add-only' />
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                    </tr>
                </table>

                <p className='w-750'><h4>Out of State Contact</h4></p>

                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Name:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Street Address:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>City/Zip:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' name='txtName1' id='txtName1' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' name='txtStreetAddress1' id='txtStreetAddress1' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' name='txtCity1' id='txtCity1' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Phone Number:</span>
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' name='txtPhoneNumber1' id='txtPhoneNumber1' className='add-only' />
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                    </tr>
                </table>

                <p className='w-750'><h3>Emergency Contact Numbers</h3></p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Name</span>
                            <input type='text' name='txtEmergencyName' id='txtEmergencyName' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Name</span>
                            <input type='text' name='txtEmergencyName1' id='txtEmergencyName1' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Phone Number</span>
                            <input type='text' name='txtEmergencyPhone' id='txtEmergencyPhone' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Phone Number</span>
                            <input type='text' name='txtEmergencyPhone1' id='txtEmergencyPhone1' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Other:</span>
                            <input type='text' name='txtEmergencyOther' id='txtEmergencyOther' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Other</span>
                            <input type='text' name='txtEmergencyOther1' id='txtEmergencyOther1' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><h3>Written Plan in Event of Emergency</h3></p>

                <p className='w-750'>
                    <span className='eleHeader'>Plan of Action:</span>
                    <textarea id='txtAction' name='txtAction' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <b>My signature below indicates that:</b>
                </p>


                <ul>
                    <li>I have received 'The Take and Go Emergency Book' and have been advised to complete it in its entirety.</li>
                    <li>I should refer to this completed booklet in case of an emergency</li>
                    <li>Lilly Pad Home Health, LLC recommends me to visit the State of Louisiana Office of Homeland Security and Emergency Preparedness Governor's website at www.getagameplan.org.</li>
                </ul>

                <table>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Client Signature </td>
                        <td className='small w-250'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Legal Guardian/Parent Signature </td>
                        <td className='small w-250'> Date </td>
                    </tr>
                </table>


                <p className='w-750'><h3>Recipient Emergency Crisis Procedure</h3></p>

                <p className='w-750'>
                    If (I/my child) have/has crisis, I will follow the steps listed below:
                </p>

                <p className='w-750'>
                    <ul>
                        <li>If I am/my child is attempting/threatening suicide or homicide I will do the following:
                            <ol type='a'>
                                <li>Call 9-1-1 immediately;</li>
                                <li>Call my Mental Health Professional (MHP/MHS) to inform him/her of status;</li>
                                <li>If I cannot reach my Mental Health Professional, I will dial the emergency number 985-503-0095.</li>
                            </ol>
                        </li>
                        <li>If there is another crisis other than homicide/suicide I will do the following:
                            <ol>
                                <li>Follow the Crisis Plan that is in my Take Home Folder.</li>
                                <li>I will contact my Mental Health Professional.</li>
                            </ol>
                        </li>
                        <li>Five Hearts Healthcare must be notified of any crisis immediately after 9-1-1 has been contacted.</li>
                    </ul>
                </p>

                <p className='w-750'><h3>NO SELF HARM</h3></p>

                <p className='w-750'>
                    I, &nbsp;
                    <input type='text' name='txtStrength' id='txtStrength' className='add-only w-250 custom-add-only' />
                    , HERBY AGREE THAT I WILL NOT HARM MYSELF IN ANY WAY, ATTEMPT SUICIDE, OR DIE BY SUICIDE.
                </p>

                <p className='w-750'>
                    <b>1-800-SUICIDE-24 HOUR SUICIDE PREVENTION LINE THAT CAN BE CALLED FROM ANYWHERE IN THE U.S</b>
                </p>

                <p className='w-750'><h4>Disclosure</h4></p>

                <p className='w-750'>
                    I understand that I am being assessed/screened to potentially be a client of Lilly Pad Home Health for behavioral health services. However, being screened/assessed does not constitute a commitment from Lilly Pad Home Health for behavioral health services. After my assessment/screening, my file will be reviewed by the appropriate parties and a decision will be made regarding services I may or may not receive. Once It is determined that I have met admission criteria and am accepted to such programs, I will be notified of such decision. I understand that I should not make any changes to my current mental/behavioral health care or discontinue services I am currently receiving until notification is given.
                </p>
                <p className='w-750'>
                    My signature below indicates that I fully understand the emergency/crisis procedure and disclosure.
                </p>

                <table>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Client/Parent/Legal Guardian </td>
                        <td className='small w-250'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Witness </td>
                        <td className='small w-250'> Date </td>
                    </tr>
                </table>


            </div>
        </form >

    )
}











